import React from 'react';
import SubmissionViewer from '../../components/admin/SubmissionViewer';

const WhistleblowerReports = () => {
  const columns = [
    { key: 'staff_name_1', label: 'Staff Name', type: 'text' },
    { key: 'incident_date_time', label: 'Incident Date', type: 'datetime' },
    { key: 'incident_location', label: 'Location', type: 'text' },
    { key: 'incident_details', label: 'Details', type: 'long-text' },
    { key: 'supporting_document_url', label: 'Document', type: 'file', bucket: 'whistleblower_documents' },
    { key: 'name', label: 'Whistleblower', type: 'text' },
    { key: 'email', label: 'Email', type: 'text' },
    { key: 'whistleblower_contact', label: 'Contact', type: 'text' },
  ];

  return (
    <SubmissionViewer 
      tableName="whistleblower_reports" 
      title="All Whistleblower Reports" 
      columns={columns} 
    />
  );
};

export default WhistleblowerReports;
